import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IWarehouseProductsGetAllParams,
  IWarehouseProductsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IWarehouseProductsResponse>>,
  IPathBaseParam,
  IPaginationParams & IWarehouseProductsGetAllParams
>("stores.warehouses.products");
const getApis = createGetApi<
  IApiResponse<IWarehouseProductsResponse>,
  IPathByIdParam,
  object
>("stores.warehouses.products");

export const products = {
  ...getAllApis,
  ...getApis,
};
